import { queryOptions } from '@tanstack/react-query';
import type { ZodSchema } from 'zod';

import type { Tanstack } from '~/queryUtils/useQuery';
import { buildQueryString, fetcher, searchParamsForQueryKey } from '~/queryUtils/useQuery';

type Props<TSchema extends ZodSchema> = {
    aggregateName: string;
    resolverName: string;
    schema: TSchema;
    searchParams?: Record<string, unknown>;
    tanstack?: Tanstack<TSchema>;
};

export const getQueryOptions = <TSchema extends ZodSchema>({
    aggregateName,
    resolverName,
    schema,
    searchParams = {},
    tanstack,
}: Props<TSchema>) => {
    const { initialData, ...restTanstack } = tanstack ?? {};

    const commonOptions = {
        ...restTanstack,
        queryFn: () =>
            fetcher({
                meta: {
                    queryUrl: `/query/${aggregateName}/${resolverName}${buildQueryString(searchParams)}`,
                    schema,
                },
            }),
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: [aggregateName, resolverName, searchParamsForQueryKey(searchParams)],
    };
    if (initialData !== undefined) {
        const parsedSchema = schema.parse(initialData);
        return queryOptions({
            ...commonOptions,
            initialData: parsedSchema,
        });
    }
    return queryOptions(commonOptions);
};
